// Component copy to Dropdown.tsx on create-scheduled-tournament
import { SelectDropdownProps } from 'react-native-select-dropdown'
import SelectDropdown from 'react-native-select-dropdown'
import backButtonImg from '../../../assets/icons/chevron-90-white.png'
import { Image, StyleSheet } from 'react-native'
import { DS } from '../../design-system'

// pick the props you need
interface DropdownProps
  extends Pick<
    SelectDropdownProps,
    'data' | 'onSelect' | 'defaultButtonText' | 'defaultValue' | 'dropdownIconPosition'
  > {}

export const Dropdown = ({ data, onSelect, defaultButtonText, defaultValue, dropdownIconPosition }: DropdownProps) => {
  return (
    <SelectDropdown
      data={data}
      onSelect={onSelect}
      buttonStyle={styles.dropdown}
      defaultButtonText={defaultButtonText}
      defaultValue={defaultValue}
      dropdownIconPosition={dropdownIconPosition}
      buttonTextStyle={{ textAlign: 'left' }}
      buttonTextAfterSelection={(selectedItem) => {
        return selectedItem
      }}
      renderDropdownIcon={(isOpened) => {
        return (
          <Image
            source={backButtonImg}
            style={[
              styles.dropdownPickerImage,
              {
                transform: [{ rotate: isOpened ? '270deg' : '90deg' }]
              }
            ]}
          />
        )
      }}
      rowTextForSelection={(item) => {
        return item
      }}
    />
  )
}

const styles = StyleSheet.create({
  dropdown: {
    height: 48,
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 5,
    paddingStart: 10,
    marginTop: 6,
    borderColor: DS.palette['Global/Black'],
    borderWidth: 1,
    width: '100%'
  },
  dropdownPickerImage: {
    width: 16,
    height: 16,
    resizeMode: 'contain',
    tintColor: DS.palette['Global/Black']
  }
})
